import React from "react";
// import {teamsHighLevelAccess} from "../../pages/Authorized/Teams/Teams";
import {user_role} from "../../storage/user";
import {TEAM_LEAD, teamsHighLevelAccess} from "./staticVariables";

export const params = {
  ordering: "ordering",
  page_size: "page_size",
  subscriptions: 'subscriptions',
  teams: 'teams',
  page: "page",
  domain: "domain",
  hidden_columns: 'hidden_columns',
  domain_address: "domain_address",
  geo: "geo",
  sub7: "sub7",
  tier: 'tier',
  created_at_after: "created_at_after",
  created_at_before: "created_at_before",
  search: "search",
  status: "status",
  is_lead: "is_lead",
  is_sale: "is_sale",
  date_from: 'date_from',
  date_to: 'date_to',
  is_installed: "is_installed",
  is_support_handled: "is_support_handled",
  purpose: "purpose",
  application_name: "application_name",
  sort: "sort",
  user: "user",
  ip_address: "ip_address",
  flow: "flow",
  country_code: "country_code",
  os: "os",
  content: 'content',
  date_time_before: "date_time_before",
  date_time_after: "date_time_after",
  email: "email",
  postback_type: "postback_type",
  postback_time: "postback_time",
  conversion_date_time: "conversion_date_time",
  conversion_type: "conversion_type"
};


export const dashboardAppsColumnsList = [
    {name: '%'},
    {name: 'name_column'},
    {name: 'сlicks_column'},
    {name: "unique_clicks"},
    {name: "installs_column"},
    {name: "leads_column"},
    {name: "dep_column"},
]

export const dashboardGeosColumnsList = [
    {name: '%'},
    {name: 'geo_column'},
    {name: 'сlicks_column'},
    {name: "unique_clicks"},
    {name: "installs_column"},
    {name: "leads_column"},
    {name: "dep_column"},
]

export const dashboardClientsColumnsList = [
    {name: '#'},
    {name: 'percentage'},
    {name: 'clients'},
    {name: 'installs'},
]

export const dashboardCategoriesColumnsList = [
    {name: '#'},
    {name: 'percentage'},
    {name: 'categories'},
    {name: 'installs'},
]

export const pixelApiHandleSupportOptions = [
  {value: "true", label: "marked"},
  {value: "false", label: "unmarked"},
];

export const pixelApiStatusOptions = [
  {value: "true", label: "active"},
  {value: "false", label: "inactive"},
];

export const sortOrderPrefixes = {
  asc: "",
  desc: "-",
};


export const subscriptionsAccountingTableOrderingList = [
  {name: "name_column"},
  {ordering: "buy_date", name: "subscription_purchase_date"},
  {name: "extra_days"},
  {name: "push_date"},
  {name: "subscription_level"},
  {name: "history"},
  {ordering: "renew_subscription", name: "autopay"},
  {name: "balance"},
  {name: "email"},
  {name: "secret_bot_key"},
  {name: "notes"},
];

export const clicksStatsOrderingList = [
  {ordering: "geo", name: "geo_column"},
  {ordering: "domain", name: "domain_column"},
  {ordering: "app__name", name: "application"},
  {ordering: "sub7", name: "sub7"},
  {ordering: "is_installed", name: "install_column"},
  {ordering: "is_lead", name: "lead"},
  {ordering: "is_sale", name: "sale"},
  {ordering: "is_unique", name: "unique"},
  {ordering: "created_at", name: "date"},
];

export const conversionStatsColumnsList = [
  {name: 'Tds_clickid'},
  {name: "application"},
  {name: "geo_column"},
  {name: "sub7"},
  {name: "click_time", ordering: "created_at"},
  {name: "conversion_time", ordering: "conversion_date_time"},
  {name: "status", ordering: "conversion_type"},
];

export const flowsActiveTabColumnsList = [
  {name: 'name_column'},
  {name: 'status_column'},
  {name: "domain_column"},
  {name: "geo_column"},
  {name: "cloaca_column"},
  {name: "applications_column"},
  teamsHighLevelAccess.includes(user_role) || user_role === TEAM_LEAD ? {name: "email"} : null,
  {name: ''}
].filter((item) => item !== null);

export const flowsExpiredTabColumnsList = [
  {name: 'name_column'},
  {name: "domain_column"},
  {name: "geo_column"},
  {name: "cloaca_column"},
  {name: "applications_column"},
  teamsHighLevelAccess.includes(user_role) || user_role === TEAM_LEAD ? {name: "email"} : null,
  {name: ''}
].filter((item) => item !== null);

export const usersStatsOrderingList = [
  {ordering: "geo", name: "geo"},
  {ordering: "app__name", name: "application"},
  {ordering: "app__bundle", name: "bundle"},
  {ordering: "email", name: "email"},
  {ordering: "offer", name: "offer"},
  {ordering: "total_clicks", name: "сlicks_column"},
  {ordering: "total_installs", name: "installs_column"},
  {ordering: "total_leads", name: "leads_column"},
  {ordering: "total_sales", name: "sales_column"},
];

export const appStatsOrderingList = [
  {name: "application"},
  {ordering: "ios_installs", name: "IOS"},
  {ordering: "pwa_installs", name: "PWA"},
  {ordering: "android_installs", name: "ANDROID"},
  {ordering: "total_installs", name: "total"},
];

export const iosUsersStatsOrderingList = [
  {name: "email"},
  // {name: "bundle"},
  {ordering: "ios_installs", name: "IOS"},
  {ordering: "pwa_installs", name: "PWA"},
  {ordering: "android_installs", name: "ANDROID"},
  {ordering: "total_installs", name: "total"},
];

export const balancesOrderingList = [
  {ordering: "email", name: "email"},
  {ordering: "offer", name: "offer"},
  {ordering: "wallet__balance", name: "balance"},
];

export const commandsWeeksColumnsList = [
  {name: "analytics.top_client"},
  {name: "team"},
  {name: "installs"},
  {name: "analytics.moving_percent"},
];

export const topBestClientsColumnsList = [
  {name: "top_best_clients"},
  {name: "team"},
  {name: "installs"},
  {name: "ratio"},
];

export const topWorstClientsColumnsList = [
  {name: "top_worst_clients"},
  {name: "team"},
  {name: "installs"},
  {name: "ratio"},
];



export const usersOrderingList = [
  {name: "email"},
  {name: "role"},
  {name: "team"},
  {ordering: "wallet__balance", name: "balances"},
  {name: "subscription"},
  {name: "subscription_start"},
  {name: "subscription_end"},
  {name: "days_remaining"},
  {name: ""},
  {name: ""}
];

export const teamsUsersOrderingList = [
  {name: "username"},
  {name: "email"},
  {name: "team"},
  {
    // ordering: "role",
    name: "role"},
  {
    // ordering: "status",
    name: "status"},
  {name: ""},
];

export const teamsTabOrderingList = [
  {name: "team"},
  // {name: "Team Lead"},
  {
    // ordering: "members_count",
    name: "members_count"},
  // {name: "subscription"},
  // {name: "subscription_start"},
  // {name: "subscription_end"},
  // {name: "days_remaining"},
  {name: ""},
];

export const postbackStatusList = [
  { value: "lead", label: "lead" },
  { value: "sale", label: "sale" },
];

export const userTypeList = [
  { value: false, label: "Обычный" },
  { value: true, label: "Партнер" },
];

export const commonClicksStatsOrderingList = [
  { ordering: "geo", name: "geo" },
  { ordering: "app__name", name: "application" },
  { ordering: "domain", name: "domain" },
  { ordering: "sub7", name: "sub7" },
  { ordering: "total_clicks", name: "сlicks_column" },
  { ordering: "unique_clicks", name: "unique_clicks" },
  { ordering: "total_installs", name: "installs_column" },
  { ordering: "total_leads", name: "leads_column" },
  { ordering: "total_sales", name: "sales_column" },
];


export const financeStatsOrderingList = [
  {name: "client"},
  {ordering: "sum", name: "payment_amount"},
];

export const geoAppStatsOrderingList = [
  { ordering: "geo", name: "Гео" },
  { ordering: "app__name", name: "Приложение" },
  { ordering: "app__bundle", name: "Бандл" },
  { ordering: "total_clicks", name: "Clicks" },
  { ordering: "total_installs", name: "Installs" },
  { ordering: "total_leads", name: "Leads" },
  { ordering: "total_sales", name: "Sales" },
];

export const geoStatsOrderingList = [
  {name: "geo"},
  {ordering: "ios_installs", name: "IOS"},
  {ordering: "android_installs", name: "ANDROID"},
  {ordering: "pwa_installs", name: "PWA"},
  {ordering: "total_installs", name: "total"},
];

export const androidCommonStatsOrderingList = [
  {ordering: "geo", name: "geo"},
  {ordering: "app__bundle", name: "bundle"},
  {ordering: "total_installs", name: "installs_column"},
  {ordering: "total_leads", name: "leads_column"},
  {ordering: "total_sales", name: "sales_column"},
];

export const statisticsStatusOptions = [
  { value: "is_lead", label: "lead" },
  { value: "is_sale", label: "sale" },
  { value: "is_installed", label: "install" },
];

export const postbackTypeStatusOptions = [
  { value: "lead", label: "lead" },
  { value: "sale", label: "sale" },
  { value: "installed", label: "install" },
];

export const postbackLogsStatusOptions = [
  { value: "success", label: "success" },
  { value: "error", label: "error" },
];

export const sortDateOptions = [
  { value: "today", label: "Сегодня" },
  { value: "yesterday", label: "Вчера" },
  { value: "this_week", label: "На этой неделе" },
  { value: "last_7_days", label: "Последние 7 дней" },
  { value: "this_month", label: "В этом месяце" },
  { value: "previous_month", label: "Предыдущий месяц" },
  { value: "last_30_days", label: "Последние 30 дней" },
  { value: "custom_date", label: "Ваша дата" },
];

export const intervalDateOptions = [
  {value: "today", label: "Сегодня"},
  {value: "yesterday", label: "Вчера"},
  {value: "last_monday", label: "Вчера"},
  {value: "7_days_ago", label: ""},
  {value: "first_day_of_this_month", label: ""},
  {value: "1_month_ago", label: ""},
  {value: "previous_month", label: "Предыдущий месяц"},
];
